var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notify"},_vm._l((_vm.getAlerts),function(alert){return _c('div',{key:alert.id},[_c('div',{staticClass:"message",class:alert.variant},[_vm._v(_vm._s(alert.message))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }